(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("impv-products/src/js/product-template-newer-design");

},{"impv-products/src/js/product-template-newer-design":7}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var makeRowFromColumns = function makeRowFromColumns(columns) {
  var cellSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.cell';
  var rows = [];

  if (columns && cellSelector) {
    _toConsumableArray(columns).forEach(function (col) {
      var cells = col.querySelectorAll(cellSelector);

      _toConsumableArray(cells).forEach(function (cell, i) {
        if (typeof rows[i] === 'undefined') {
          rows[i] = [];
        }

        rows[i].push(cell);
      });
    });
  }

  return rows;
};

var _default = makeRowFromColumns;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _makeRowsFromColumns = _interopRequireDefault(require("./make-rows-from-columns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RowHoverHelper =
/*#__PURE__*/
function () {
  function RowHoverHelper(holder, opts) {
    _classCallCheck(this, RowHoverHelper);

    if (holder) {
      this.opts = Object.assign({
        holderSelector: '.table-body',
        hoverClass: 'highlited',
        columns: '.table-cell',
        cellsClass: 'cell'
      }, opts);
      this.holder = holder;
      this.init();
    }
  }

  _createClass(RowHoverHelper, [{
    key: "init",
    value: function init() {
      this.rows = [];
      this.findElements();
      this.updateRows();
      this.attachEvents();
      this.isInited = true;
    }
  }, {
    key: "findElements",
    value: function findElements() {
      this.columns = this.holder.querySelectorAll(this.opts.columns);
      this.allCells = this.holder.querySelectorAll(".".concat(this.opts.cellsClass));
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.onMouseOver = function (e) {
        var t = e.target;
        var cell = null;
        var parent = t.closest(".".concat(_this.opts.cellsClass));

        if (t.classList.contains(_this.opts.cellsClass)) {
          cell = t;
        } else if (parent) {
          cell = parent;
        }

        if (cell) {
          _this.makeHighlight(cell);
        }
      };

      this.onMouseOut = function (e) {
        var currentTarget = e.currentTarget,
            relatedTarget = e.relatedTarget;

        if (!relatedTarget || relatedTarget !== currentTarget && !relatedTarget.closest(_this.opts.holderSelector)) {
          _this.removeHighlight();
        }
      };

      this.holder.addEventListener('mouseover', this.onMouseOver);
      this.holder.addEventListener('mouseout', this.onMouseOut);
    }
  }, {
    key: "makeHighlight",
    value: function makeHighlight(activeCell) {
      var _this2 = this;

      if (activeCell) {
        this.rows.forEach(function (row) {
          row.forEach(function (cell) {
            if (row.indexOf(activeCell) > -1) {
              cell.classList.add(_this2.opts.hoverClass);
            } else {
              cell.classList.remove(_this2.opts.hoverClass);
            }
          });
        });
      }
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      var _this3 = this;

      _toConsumableArray(this.allCells).forEach(function (cell) {
        cell.classList.remove(_this3.opts.hoverClass);
      });
    }
  }, {
    key: "updateRows",
    value: function updateRows() {
      this.rows = (0, _makeRowsFromColumns["default"])(this.columns, ".".concat(this.opts.cellsClass)) || [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isInited) {
        this.holder.removeEventListener('mouseover', this.onMouseOver);
        this.holder.removeEventListener('mouseout', this.onMouseOut);
        this.removeHighlight();
      }
    }
  }]);

  return RowHoverHelper;
}();

var _default = RowHoverHelper;
exports["default"] = _default;

},{"./make-rows-from-columns":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SlickWithIndicator =
/*#__PURE__*/
function () {
  function SlickWithIndicator(holder) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SlickWithIndicator);

    this.options = Object.assign({
      slick: '.slider',
      indicator: '.slides-indicator',
      slickOpts: {}
    }, opts);

    if (holder) {
      this.holder = holder;
      this.init();
    }
  }

  _createClass(SlickWithIndicator, [{
    key: "init",
    value: function init() {
      this.findElems();
      this.attachEvents();
    }
  }, {
    key: "findElems",
    value: function findElems() {
      this.$slickSlider = jQuery(this.holder.querySelector(this.options.slick));
      this.indicator = this.holder.querySelector(this.options.indicator);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.initTimer = null;

      this.onSlickInit = function (e, s) {
        // set timeout fixes this issue
        // https://github.com/kenwheeler/slick/issues/1802
        clearTimeout(_this.initTimer);
        _this.initTimer = setTimeout(function () {
          var currentSlide = s.currentSlide;

          if (_this.indicator) {
            _this.makeIndicator({
              current: currentSlide,
              step: _this.$slickSlider.slick('slickGetOption', 'slidesToScroll')
            });
          }
        }, 0);
      };

      this.onSlickBeforeChange = function (e, s, cur, next) {
        if (_this.indicator) {
          _this.makeIndicator({
            current: next,
            step: _this.$slickSlider.slick('slickGetOption', 'slidesToScroll')
          });
        }
      };

      this.$slickSlider.on('init', this.onSlickInit).slick(this.options.slickOpts).on('beforeChange', this.onSlickBeforeChange);
    }
  }, {
    key: "setProps",
    value: function setProps(elem) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (elem) {
        props.forEach(function (d) {
          var prop = d.prop,
              val = d.val;
          elem.style.setProperty(prop, val);
        });
      }
    }
  }, {
    key: "calcProps",
    value: function calcProps(_ref) {
      var current = _ref.current,
          step = _ref.step;
      var totalSteps = this.getDotCount();
      var currentStep = Math.floor(current / step);
      return {
        width: "".concat(1 / totalSteps * 100, "%"),
        left: "".concat(currentStep / totalSteps * 100, "%")
      };
    }
  }, {
    key: "buildProps",
    value: function buildProps() {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return [{
        prop: '--indicator-width',
        val: width
      }, {
        prop: '--indicator-left',
        val: left
      }];
    }
  }, {
    key: "makeIndicator",
    value: function makeIndicator() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        current: 1,
        step: 1
      };

      if (this.indicator) {
        // calc width and left
        var _this$calcProps = this.calcProps(opts),
            width = _this$calcProps.width,
            left = _this$calcProps.left; // build array with props


        var props = this.buildProps(width, left); // apply props to indicator

        this.setProps(this.indicator, props);
      }
    }
  }, {
    key: "getDotCount",
    value: function getDotCount() {
      var _ = this.$slickSlider.slick('getSlick');

      var breakPoint = 0;
      var counter = 0;
      var pagerQty = 0;

      if (_.options.infinite === true) {
        if (_.slideCount <= _.options.slidesToShow) {
          ++pagerQty;
        } else {
          while (breakPoint < _.slideCount) {
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
          }
        }
      } else if (_.options.centerMode === true) {
        pagerQty = _.slideCount;
      } else if (!_.options.asNavFor) {
        pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }

      return pagerQty;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this.initTimer);
      this.$slickSlider.off('init', this.onSlickInit).off('beforeChange', this.onSlickBeforeChange).slick('unslick');
    }
  }], [{
    key: "jqueryInit",
    value: function jqueryInit(elOrSelector) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      jQuery(elOrSelector).each(function (i, el) {
        jQuery(el).data('SlickWithIndicator', new SlickWithIndicator(el, opts));
      });
    }
  }, {
    key: "jqueryDestroy",
    value: function jqueryDestroy(elOrSelector) {
      jQuery(elOrSelector).each(function (i, el) {
        var $el = jQuery(el);
        var data = $el.data('SlickWithIndicator');

        if (data) {
          data.destroy();
          $el.removeData('SlickWithIndicator');
        }
      });
    }
  }]);

  return SlickWithIndicator;
}();

exports["default"] = SlickWithIndicator;

},{}],5:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

window.addEventListener('DOMContentLoaded', function () {
  var onYouTubeIframeAPIReadyCallbacks = [];
  var ytIsReady = false;
  YTdeferred();

  window.onYouTubeIframeAPIReady = function () {
    onYouTubeIframeAPIReadyCallbacks.forEach(function (cb) {
      cb();
    });
    ytIsReady = true;
  };

  function YTdeferred() {
    if (window.hideYTActivated) return;

    _toConsumableArray(document.querySelectorAll('.hytPlayerWrap iframe')).forEach(function (iframe) {
      var modal = iframe.closest('.modal');
      var $m = $(modal);

      if (modal) {
        modal.classList.add('yt-deferred-video-modal');
        $m.on('shown.bs.modal', function () {
          if (iframe.getAttribute('data-created')) {
            play(iframe);
          } else {
            iframe.setAttribute('data-created', true);
            buildPlayer(iframe);
          }
        });
        $m.on('hidden.bs.modal', function () {
          stop(iframe);
        });
      }
    });

    window.hideYTActivated = true;

    function buildPlayer(iframe) {
      if (!document.getElementById('youtube-js-script')) {
        createScript();
      }

      initYT(iframe);
      setSrc(iframe);
    }

    function setSrc(iframe) {
      var videoSrc = iframe.getAttribute('vidurl');
      var srcForYoutube = videoSrc + '?enablejsapi=1&rel=0';

      var onIframeLoad = function onIframeLoad(e) {
        var modal = e.target.closest('.modal');

        if (modal) {
          modal.classList.add('player-loaded');
        }
      };

      if (videoSrc.indexOf('vimeo') === -1) {
        iframe.addEventListener('load', onIframeLoad);
        iframe.setAttribute('src', srcForYoutube);
      }
    }

    function initYT(iframe) {
      var playerWrap = iframe.closest('.hytPlayerWrap');

      var onPlayerStateChange = function onPlayerStateChange(event) {
        if (playerWrap) {
          if (event.data == YT.PlayerState.ENDED) {
            playerWrap.classList.add('ended');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playerWrap.classList.add('paused');
          } else if (event.data == YT.PlayerState.PLAYING) {
            playerWrap.classList.remove('ended');
            playerWrap.classList.remove('paused');
          }
        }
      };

      var onPlayerReady = function onPlayerReady(e) {
        var target = e.target;
        var iframe = target.h;
        var modal = iframe.closest('.modal');

        if (modal) {
          if (modal.classList.contains('show')) {
            target.playVideo();
          }
        }
      };

      var initFn = function initFn() {
        var player = new YT.Player(iframe, {
          events: {
            onStateChange: onPlayerStateChange,
            onReady: onPlayerReady
          }
        });

        if (playerWrap) {
          playerWrap.addEventListener('click', function (e) {
            if (e.target.className === 'close') {
              return;
            }

            var playerState = player.getPlayerState();

            if (playerState == YT.PlayerState.ENDED) {
              player.seekTo(0);
            } else if (playerState == YT.PlayerState.PAUSED) {
              player.playVideo();
            }
          });
        }
      };

      if (ytIsReady) {
        initFn();
      } else {
        onYouTubeIframeAPIReadyCallbacks.push(initFn);
      }
    }

    function play(iframe) {
      iframe.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"playVideo\",\"args\":\"\"}", '*');
    }

    function stop(iframe) {
      iframe.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"stopVideo\",\"args\":\"\"}", '*');
    }

    function createScript() {
      var scriptYT = document.createElement('script');
      var firstScriptTag = document.getElementsByTagName('script')[0];
      scriptYT.setAttribute('id', 'youtube-js-script');
      scriptYT.setAttribute('src', 'https://www.youtube.com/iframe_api');
      firstScriptTag.parentNode.insertBefore(scriptYT, firstScriptTag);
    }
  }
});

},{}],6:[function(require,module,exports){
"use strict";

/*!
 * jQuery serialshuffle
 * https://github.com/kevinmeunier/jquery-serialshuffle
 *
 * Copyright 2022 Meunier Kévin
 * https://www.meunierkevin.com
 *
 * Released under the MIT license
 *
 *  DC: edited to use url for images (not file name)
 */
(function ($) {
  'use strict'; // Removing a element in an array based on the value

  Array.prototype.remove = function () {
    var what,
        a = arguments,
        L = a.length,
        ax;

    while (L && this.length) {
      what = a[--L];

      while ((ax = this.indexOf(what)) !== -1) {
        this.splice(ax, 1);
      }
    }

    return this;
  };

  $.fn.serialshuffle = function (options) {
    var settings = $.extend({}, $.fn.serialshuffle.defaults, options);
    var base = this;
    var lastrandom;

    var _random;

    $.extend(this, {
      init: function init() {
        // Browsing the available lists
        this.each(function () {
          var $list = $(this);
          var data = {
            max: $list.children().length,
            lastrandom: undefined,
            arrBefore: settings.shuffle,
            arrCurrent: [],
            arrAfter: []
          }; // Storage of the currently displayed images

          $list.find('img').each(function () {
            // const filename = base.getFilename($(this));
            var filename = $(this).attr('src'); // DC: edit to use full url

            if (filename !== null) {
              data.arrCurrent.push(filename);
            }
          }); // Initialisation

          setInterval(function () {
            base.shuffle($list, data);
          }, settings.speed);
        });
      },
      random: function random(data) {
        while (_random === data.lastrandom) {
          _random = Math.floor(Math.random() * data.max);
        }

        data.lastrandom = _random;
        return _random;
      },
      shuffle: function shuffle($list, data) {
        // Restarting the loop
        if (!data.arrBefore.length) {
          data.arrBefore = data.arrAfter;
          data.arrAfter = [];
        } // Setup


        var randIndex = base.random(data);
        var $target = $list.children().eq(randIndex);
        var prevFilename = base.getFilename($target.find('img'));
        var nextFilename = data.arrBefore[Math.floor(Math.random() * data.arrBefore.length)]; // Hide the previous logo

        $target.find('img').fadeOut(1000, function () {
          $(this).remove();
        }); // Show the new logo

        $('<span class="sub-animate"><img src="' + settings.folder + nextFilename + '" alt=""></span>').appendTo($target).animate({
          opacity: 1
        }, 1000, function () {
          $(this).children().unwrap();
        }); // Reinitialisation

        data.arrBefore.remove(nextFilename);
        data.arrCurrent.remove(prevFilename);
        data.arrCurrent.push(nextFilename);
        data.arrAfter.push(prevFilename);
      },
      getFilename: function getFilename($element) {
        // return $element.attr('src').replace(/^.*[\\\/]/, ''); // DC: return file name
        return $element.attr('src'); // DC: return full url
      }
    });
    this.init();
    return this;
  };

  $.fn.serialshuffle.defaults = {
    folder: '',
    stack: [],
    speed: 2000
  };
})(jQuery);

},{}],7:[function(require,module,exports){
(function (global){
"use strict";

var _rowHoverHelper = _interopRequireDefault(require("./components/row-hover-helper"));

var _slickWithIndicator = _interopRequireDefault(require("./components/slick-with-indicator"));

require("impv/src/js/components/stycky-pagination.js");

require("./components/youtube-deferred");

require("./jquery-plugins/jquery-serialshuffle.js");

require("impv-support/src/js/components/smooth-scroll");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// import './components/jquery-tabs';
jQuery(function () {
  initInViewport();
  initPosition();
  InitTabsHeight();
  initSameHeight();
  initSlick();
  initSlickCarousel();
  initCustomHover();
  initAddClasses();
  initRowHover();
  initTabs();
  initStickyScrollBlock();
  initAnchorNavigation();
  initToggle(); // initShiftRelatedResource();

  initValuePropHover();
  initInnerScroll();
  initFAQAccordion();
  initEnlargeModal();
  initRichTabsHover();
  initShowMore();
});
$(window).on('load', function () {
  initRichTabs();
});
$(function () {
  $('.modal').each(function () {
    var src = $(this).find('iframe').attr('src');
    $(this).on('click', function () {
      $(this).find('iframe').attr('src', '');
      $(this).find('iframe').attr('src', src);
    });
  });
  $('a').has('img').addClass('not-link');
  $('a[class^=btn]').addClass('not-link');
  $('.author-name-anchor').mouseenter(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-avatar-anchor[href="' + $(e.currentTarget).attr('href') + '"]').find('.author-avatar').addClass('hover-element');
  }).mouseleave(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-avatar-anchor[href="' + $(e.currentTarget).attr('href') + '"]').find('.author-avatar').removeClass('hover-element');
  });
  $('.author-avatar-anchor').mouseenter(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-name-anchor[href="' + $(e.currentTarget).attr('href') + '"]').addClass('hover-element');
  }).mouseleave(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-name-anchor[href="' + $(e.currentTarget).attr('href') + '"]').removeClass('hover-element');
  });
}); // DC: /util/responsive-helper.js deals with window resize, but it does not have access to these functions

$(window).on('resize', function () {
  initRichTabsResize();
}); // DC: image enlarge modal in portfolio panels (could be extended for other panels)

function initEnlargeModal() {
  var container = document.getElementById('portfolio-accordion');
  var modal = document.getElementById('enlarge-modal');
  var modalImg = document.getElementById('modal-img');
  var imgIds = [];
  var imgDivs = document.getElementsByClassName('image-enlarge');

  for (var x = 0; x < imgDivs.length; x++) {
    var id = imgDivs[x].id;
    imgIds.push(id);
  }

  imgIds.forEach(function (id) {
    console.log(id);
    var imgId = document.getElementById(id); // DC: the webp picture function does not add in ID tag :(
    // this makes it more difficult to get the img src
    // it is the only <img> inside the only .image-container div in the imgDiv object

    var pictures = imgId.getElementsByClassName('image-container');
    var imgs = pictures[0].getElementsByTagName('img');
    var imgSrc = imgs[0].dataset.src; // image click

    imgId.addEventListener('click', function () {
      modal.classList.remove('closed');
      modal.classList.add('open');
      modalImg.src = imgSrc;
    });
  }); // When the user clicks on modal, close with animation - no need for loop, it's universal

  if (modal !== null) {
    modal.onclick = function () {
      modal.classList.remove('open');
      modal.classList.add('closed');
    };
  }
} // DC: rich panels show more - could be reused


function initShowMore() {
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  });
  $('.tab-box').each(function () {
    var panelId = $(this).data('panel-id');
    var tabId = $(this).data('tab-id');
    $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').on('click', function () {
      $('#panel-' + panelId + '-tab-' + tabId + ' .tab-content').toggleClass('show-mob');
      $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').toggleClass('opened');

      if ($('#panel-' + panelId + '-tab-' + tabId + ' .tab-content').hasClass('show-mob')) {
        $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').html('Show less');
      } else {
        $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').html('Show more');
      }
    });
  });
}

function createBoxHeightAttr(pid, tid) {
  var boxElem = $('#panel-' + pid + '-tab-' + tid),
      boxesRow = $('#panel-' + pid + '-boxes-row'),
      boxHeight = Math.round(boxElem.outerHeight());

  if ($(window).width() > 767) {
    boxElem.attr('data-height', boxHeight);

    if (boxElem.hasClass('active-box')) {
      boxesRow.height(boxHeight);
    }
  } else {
    boxesRow.removeAttr('style');
  }
} // DC: load content into alternative div at breakpoints, to allow different designs
// DC: Figma has design at 1200px, the window.width is not entirely accurate, so using a lesser value than 1200 for logic


function initRichTabs() {
  // DC: allow multi panels on page
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  }); // DC: work on each panel individually

  $.each(panelIds, function (index, value) {
    $('.tab-box').each(function () {
      var panelId = $(this).data('panel-id');
      var tabId = $(this).data('tab-id');
      createBoxHeightAttr(panelId, tabId); // DC: large desktop

      if ($(window).width() >= 1150) {
        $('#panel-' + panelId + '-tab-' + tabId + ' .tab-intro').contents().appendTo('#panel-' + panelId + '-button-' + tabId + ' .intro');
      }
    });
  });
} // DC: for use on window resize, check for div content and move if required


function initRichTabsResize() {
  // DC: allow multi panels on page
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  }); // DC: work on each panel individually

  $.each(panelIds, function (index, value) {
    $('.tab-box').each(function () {
      var panelId = $(this).data('panel-id');
      var tabId = $(this).data('tab-id'); // Create height data attribute for animation

      createBoxHeightAttr(panelId, tabId); // DC: large desktop

      if ($(window).width() < 1150) {
        $('#panel-' + panelId + '-button-' + tabId + ' .intro').contents().appendTo('#panel-' + panelId + '-tab-' + tabId + ' .tab-intro');
      } else if ($(window).width() >= 1150) {
        $('#panel-' + panelId + '-tab-' + tabId + ' .tab-intro').contents().appendTo('#panel-' + panelId + '-button-' + tabId + ' .intro');
      }
    });
  });
} // DC: richer tabs switch content on button hover


function initRichTabsHover() {
  // DC: allow multi panels on page
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  }); // DC: work on each panel individually

  $.each(panelIds, function (index, value) {
    $('.tab-holder').each(function () {
      var panelId = $(this).data('panel-id');
      var tabId = $(this).data('tab-id'); // Create height data attribute for animation

      createBoxHeightAttr(panelId, tabId);
      $('#panel-' + panelId + '-button-' + tabId).on('mouseenter', function () {
        $('#panel-' + panelId + '-button-row .tab-link').removeClass('active-tab');
        $('#panel-' + panelId + '-holder-' + tabId + ' .tab-link').addClass('active-tab');
        $('#panel-' + panelId + '-boxes-row .tab-box').removeClass('active-box');
        $('#panel-' + panelId + '-tab-' + tabId + '.tab-box').addClass('active-box'); // Utilize height data attribute for animation

        if ($(window).width() > 767) {
          var boxesRow = $('#panel-' + panelId + '-boxes-row'),
              boxesRowPanel = $('#panel-' + panelId + '-tab-' + tabId);
          boxesRow.height(boxesRowPanel.attr('data-height'));
        }
      });
    });
  });
} //DC: inner scroll


function initInnerScroll() {
  var previousScroll = 0;
  var panelIds = []; // DC: panel IDs may not be sequential, get from panel data attr

  $('.inner-scroll-panel').each(function () {
    var data = $(this).data('sequence');
    panelIds.push(data);
  });
  $(window).on('scroll', function () {
    var currentScroll = $(this).scrollTop(); // DC: process each panel ID

    $.each(panelIds, function (index, value) {
      var panelId = '#inner-scroll-panel-' + value; // DC: no. of scroll sections = no. of image holders

      var sections = $(panelId + ' #img-col-id-' + value + ' .img-holder').length;

      for (var i = 1; i <= sections; i++) {
        if (currentScroll > previousScroll) {
          // DC: scroll down
          if (i < sections) {
            // DC: only proceed if this is not the last section
            if ($(window).scrollTop() >= $(panelId + ' #text-section-' + i).offset().top + $(panelId + ' #text-section-' + i).outerHeight() - window.innerHeight) {
              // DC: proceed only in this div - do not proceed when reach next div
              var element = $(panelId + ' #content-container-' + i);

              if ($(window).scrollTop() > element.offset().top + element.height()) {
                // DC: trigger on scroll to bottom of text container (as it is about to disappear off screen)
                $(panelId + ' #img-holder-' + (i + 1)).attr('class', 'img-holder on-screen');
                $(panelId + ' #img-holder-' + i).attr('class', 'img-holder off-screen');
                $(panelId + ' #progress-item-' + i).attr('class', 'progress-item inactive');
                $(panelId + ' #progress-item-' + (i + 1)).attr('class', 'progress-item active');
              }
            }
          }
        } else {
          // DC: scroll up
          if (i > 1) {
            // DC: dynamic change div section above - omit first section, as no section above
            var divTop = $(panelId + ' #content-container-' + (i - 1)).offset().top;
            var divBottom = divTop + $(panelId + ' #content-container-' + (i - 1)).outerHeight();

            if ($(window).scrollTop() >= divTop && $(window).scrollTop() <= divBottom) {
              // DC: make ALL other sections off-screen and inactive progress bar
              // this is to allow the inner navigation quick scroll to function correctly
              // the old method of systematically changed the previous section on scroll up could not process quick enough
              var allImg = $(panelId + ' .img-holder').map(function () {
                $(this).attr('class', 'img-holder off-screen');
              }).get(),
                  allProg = $(panelId + ' .progress-item').map(function () {
                $(this).attr('class', 'progress-item inactive');
              }).get();
              $(panelId + ' #img-holder-' + (i - 1)).attr('class', 'img-holder on-screen');
              $(panelId + ' #progress-item-' + (i - 1)).attr('class', 'progress-item active');
            }
          }
        }
      }
    });
    previousScroll = currentScroll;
  });
} // DC: add .dotted class where necessary on desktop+ devices (this will truncate text)


function initPossibleDotted() {
  // DC: window.width is not exact, so use 1000px to ensure class is added for desktop+ (1024px)
  $('.possible-dotted').addClass('css-dotted');
} // for toggling Boxes Panel block


function initToggle() {
  $('.js-toggle').on('click', function () {
    // show extra boxes
    if ($(this).hasClass('show')) {
      $(this).removeClass('show').addClass('hide');
      $('.js-overflow').removeClass('hide');
    } // hide extra boxes
    else {
        $(this).addClass('show').removeClass('hide');
        $('.js-overflow').addClass('hide overflow-hide');
      }
  });
  /* additional classes for more/less boxes (overflow) */

  if ($('.js-overflow').length > 0) {
    var overflow_height = $('.js-overflow').outerHeight() + 30;
    $('.js-overflow').attr('style', "height: ".concat(overflow_height, "px")).addClass('hide overflow-hide');
  } // add addtional class after transition for outerglow css


  $('.js-overflow').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
    if (!$(this).hasClass('hide')) {
      $(this).removeClass('overflow-hide');
    }
  });
  $(window).on('resize', function () {
    // reset overflow to show everything in order to determine correct height
    if ($('.js-overflow').hasClass('hide')) {
      $('.js-overflow').removeClass('hide overflow-hide'); // show more/less button

      $('.js-toggle').removeClass('show').addClass('hide');
    } // determine new height


    $('.js-overflow').removeAttr('style');
    var overflow_height = $('.js-overflow').outerHeight() + 30;
    $('.js-overflow').attr('style', "height: ".concat(overflow_height, "px")); // close overflow

    $('.js-overflow').addClass('hide overflow-hide'); // show more/less button

    $('.js-toggle').addClass('show').removeClass('hide');
  });
} // Value Prop Hover


function initValuePropHover() {
  // Click events for mobile/tablet, mouseover for desktop
  var responsiveEvent = window.innerWidth < 1199.98 ? 'click' : 'mouseover';
  $('.js-hover-cta').on(responsiveEvent, function () {
    // reset all cards
    $('.js-hover-card').removeClass('hover'); // hover only this card

    var card_id = $(this).attr('data-card'),
        card_elem = $('#' + card_id);
    card_elem.addClass('hover');
  });
  $('.js-hover-card-close').on('click', function () {
    $('.js-hover-card').removeClass('hover');
  });
  $('.js-hover-out').on('mouseover', function () {
    $('.js-hover-card').removeClass('hover');
  });
} // align blocks height


function initSameHeight() {
  jQuery('.info-boxes').sameHeight({
    elements: '.strip-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.proof-point',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.above-rule',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.header-wrapper',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.explain-section').sameHeight({
    elements: '.content-box h3',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.how-imperva-can-help').sameHeight({
    elements: '.box h3',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.content-panels').sameHeight({
    elements: '.panel-title',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.gpi-panel').sameHeight({
    elements: 'h3.quote',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('#resources-slider').sameHeight({
    elements: '.tile-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('#blog-slider').sameHeight({
    elements: '.tile-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  }); // DC: now match card sizes which are in different sliders for mobile (they appear as 1 list)

  jQuery('.resources-wrapper').sameHeight({
    elements: '.same-height-mob',
    flexible: true,
    multiLine: true,
    biggestHeight: true,
    breakpoint: 768
  });
}

function initSlick() {
  _slickWithIndicator["default"].jqueryInit('.related-row', {
    slick: '.related-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToScroll: 3,
      slidesToShow: 3,
      rows: 0,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    }
  });

  _slickWithIndicator["default"].jqueryInit('.related-row-1', {
    slick: '.related-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToScroll: 1,
      slidesToShow: 1,
      arrow: false,
      dots: true,
      rows: 0,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      variableWidth: true,
      responsive: [{
        // DC: settings for breakpoint value and down, initial settings used for breakpoint value and up
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          dots: false
        }
      }]
    }
  }); // DC: note responsive removal of slider requires page refresh (or new page load)


  ResponsiveHelper.addRange({
    '0..767': {
      on: function on() {
        _slickWithIndicator["default"].jqueryInit('.related-row-2', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });

        _slickWithIndicator["default"].jqueryInit('.related-row-3', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });
      },
      off: function off() {
        /* do nothing */
      }
    },
    '768': {
      on: function on() {
        _slickWithIndicator["default"].jqueryInit('.related-row-3.more-than-three', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });
      },
      off: function off() {
        /* do nothing */
      }
    }
  });

  _slickWithIndicator["default"].jqueryInit('.panels-row', {
    slick: '.panels-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      pauseOnHover: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    }
  });
} // slick init


function initSlickCarousel() {
  ResponsiveHelper.addRange({
    '..1199': {
      on: function on() {
        jQuery('.plans-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          variableWidth: true
        });
        jQuery('.table-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-for').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-titles1').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-titles2').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          draggable: false,
          swipe: false,
          asNavFor: '.slider-pagination'
        });
      },
      off: function off() {
        jQuery('.plans-slider').slick('unslick');
        jQuery('.table-slider').slick('unslick');
        jQuery('.slider-for').slick('unslick');
        jQuery('.slider-titles1').slick('unslick');
        jQuery('.slider-titles2').slick('unslick');
      }
    }
  });
  ResponsiveHelper.addRange({
    '768..1199': {
      on: function on() {
        jQuery('.measure-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          asNavFor: '.slider-pagination'
        });
      },
      off: function off() {
        jQuery('.measure-slider').slick('unslick');
      }
    }
  });
  jQuery('.study-slider').slick({
    slidesToScroll: 1,
    rows: 0,
    prevArrow: '<button class="slick-prev"></button>',
    nextArrow: '<button class="slick-next"></button>',
    autoplaySpeed: 5000,
    draggable: false,
    pauseOnHover: false,
    swipe: false,
    touchMove: false
  });
}

function initFAQAccordion() {
  if (jQuery('.faq-panel').length > 0 && jQuery('.faq-tabset li').length > 0) {
    var FAQli = jQuery('.js-faq-tabset > li'),
        FAQAnswer = FAQli.find('.answer');
    FAQli.each(function (index) {
      var item = jQuery(this),
          question = item.find('.question'),
          answer = item.find('.answer'),
          itemHeight = answer.height(); // get height of answer elements

      answer.attr('data-height', itemHeight); // only set the first answer visible

      if (index === 0) {
        answer.height(itemHeight);
        item.addClass('active');
      } else {
        answer.height(0);
      } // set click event handler


      question.on('click', function (e) {
        e.preventDefault;
        var thisQuestion = jQuery(this),
            thisQuestionActive = thisQuestion.parent().hasClass('active'); // Clear everything

        FAQli.removeClass('active');
        FAQAnswer.height(0); // 0 height minus padding
        // active flag check to close item that was open

        if (!thisQuestionActive) {
          // Activate and open this item
          thisQuestion.parent().addClass('active');
          var answerHeight = thisQuestion.parent().find('.answer').attr('data-height');
          thisQuestion.parent().find('.answer').height(answerHeight); // Piwik tracking

          _paq.push(['trackEvent', 'FAQ panel', 'Click', thisQuestion.text()]);
        }
      });
    }); // reset attributes if user resizes window

    jQuery(window).on('resize', function () {
      FAQAnswer.each(function (index) {
        var item = jQuery(this);
        item.removeAttr('style');
        var itemHeight = item.height();
        item.attr('data-height', itemHeight);
        var parentActive = item.parent().hasClass('active');
        if (!parentActive) item.height(0);
      });
    });
  }
}

function initTabs() {
  var holder = document.querySelector('.switcher-list');
  var changeEvt = new Event('ontabschange');
  var switchedByInput = false;
  jQuery(holder).tabset({
    tabLinks: 'a',
    addToParent: true,
    autoHeight: true,
    checkHash: true,
    onChange: function onChange(activeLink) {
      if (activeLink) {
        var id = activeLink.attr('href').replace('#', ''); // trigger input's checked state

        triggerInputs(id);
      }

      document.dispatchEvent(changeEvt); // scroll to table if tabs were swithced by inputs

      if (switchedByInput) {
        var activeTab = this.getActiveTab();
        switchedByInput = false;

        if (activeTab.length) {
          scrollToTable(activeTab);
        }
      }
    }
  });
  jQuery('.portfolio-tabset').tabset({
    tabLinks: 'a',
    addToParent: true,
    defaultTab: true,
    tabUnderlineClass: 'js-underline-slide'
  });
  var api = jQuery(holder).data('Tabset');
  var inputs = document.querySelectorAll('.switch input[data-target]');
  var attrName = 'data-checked-by-tab';

  _toConsumableArray(inputs).forEach(function (input) {
    input.addEventListener('change', onChange);
  });

  function onChange(e) {
    var target = e.target;
    var checkedByLink = target.getAttribute(attrName);
    var id = target.getAttribute('data-target');

    if (!checkedByLink && id) {
      var linkIdx = getLinkIndex(id);

      if (linkIdx !== null) {
        switchedByInput = true;
        api.activeTabIndex = linkIdx;
        api.switchTabs();
      }
    }
  }

  function triggerInputs(id) {
    if (id) {
      var _inputs = document.querySelectorAll("input[data-target=\"".concat(id, "\"]"));

      _toConsumableArray(_inputs).forEach(function (input) {
        input.checked = true;
        input.setAttribute(attrName, true);
        clearTimeout(input.checkedTimer);
        input.checkedTimer = setTimeout(function (input) {
          input.removeAttribute(attrName);
        }, 500, input);
      });
    }
  }

  function scrollToTable(holder) {
    var scrollTarget = holder.find('.table-section');

    if (scrollTarget.length) {
      scrollTarget[0].scrollIntoView(true);
    }
  }

  function getLinkIndex(id) {
    var result = null;

    if (holder) {
      var links = holder.querySelectorAll('a');

      _toConsumableArray(links).forEach(function (link, i) {
        if (link.getAttribute('href') === "#".concat(id)) {
          result = i;
        }
      });
    }

    return result;
  }
} // add class on click


function initAddClasses() {
  jQuery('.icon-tooltip').clickClass({
    classAdd: 'opened'
  });
  jQuery('.search-opener').clickClass({
    classAdd: 'active',
    addToParent: 'search-bar'
  });
  jQuery('.search-opener').on('click', function () {
    jQuery('.hero-search .search-input').focus();
  });
} // add classes on hover/touch


function initCustomHover() {
  jQuery('.icon-tooltip').touchHover({
    hoverClass: 'opened'
  });
}

function initRowHover() {
  var tables = document.querySelectorAll('.table-section .table-body');
  var apiList = [];
  ResponsiveHelper.addRange({
    '1024..': {
      on: function on() {
        _toConsumableArray(tables).forEach(function (table) {
          apiList.push(new _rowHoverHelper["default"](table));
        });
      },
      off: function off() {
        apiList.forEach(function (api) {
          api.destroy();
          api = null;
        });
      }
    }
  });
} // initialize sticky blocks on scroll


function initStickyScrollBlock() {
  var tabsHolder = jQuery('.page-content');
  var changingClass = 'tabs-changing';
  jQuery('.thead1').stickyScrollBlock({
    container: '#table',
    showAfterScrolled: true,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });
  jQuery('.thead2').stickyScrollBlock({
    container: '#table2',
    showAfterScrolled: true,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });

  var ontabschangeFn = function ontabschangeFn() {
    tabsHolder.addClass(changingClass);
    jQuery('.sticky-wrap-table-head .table-head').each(function () {
      var $el = jQuery(this);
      var api = $el.data('StickyScrollBlock');

      if (api) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(function (api) {
          api.onResize();
          tabsHolder.removeClass(changingClass);
        }, 300, api);
      }
    });
  };

  var refreshSize = function refreshSize() {
    jQuery('.sticky-wrap-table-head .table-head').each(function () {
      var $el = jQuery(this);
      var api = $el.data('StickyScrollBlock');

      if (api) {
        api.onResize();
      }
    });
  };

  document.addEventListener('ontabschange', ontabschangeFn);
  document.addEventListener('affixHeaderHeightChanged', refreshSize);
} // Inner anchor navigation


function initAnchorNavigation() {
  if ($('.js-anchor-navigation').length > 0) {
    new SmoothScroll({
      anchorLinks: '.js-anchor-navigation > a',
      extraOffset: 60,
      activeClasses: 'child',
      anchorActiveClass: 'active',
      wheelBehavior: 'none'
    });
  }
}
/*
 * Responsive Layout helper
 */


window.ResponsiveHelper = function ($) {
  // init variables
  var handlers = [],
      prevWinWidth,
      win = $(window),
      nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = win.width();

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      $.each(handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each(rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        $.each(rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
      var tabSelected = $('.portfolio-tabset li.active'),
          tabSelectedUnderline = $('.portfolio-tabset li.js-underline-slide');

      if (winWidth > 1024 && tabSelected.length > 0 && tabSelectedUnderline.length > 0) {
        $('.portfolio-tabset').each(function (index) {
          var thisTabSelected = $(this).find('li.active'),
              thisTabSelectedUnderline = $(this).find('li.js-underline-slide');
          var tabPadding = winWidth > 1200 ? 30 : winWidth > 1024 ? 10 : 0,
              tabSelectedLeft = thisTabSelected.position().left + tabPadding,
              tabSelectedWidth = thisTabSelected.width();
          thisTabSelectedUnderline.css({
            left: tabSelectedLeft,
            width: tabSelectedWidth
          });
        });
      }
    }
  }

  win.bind('load resize orientationchange', resizeHandler); // test range

  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      $.each(ranges, function (property, data) {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}(jQuery);

function initPosition() {
  var itemList = document.querySelector('.measure-list');

  if (!itemList || itemList.classList.contains('light')) {
    return;
  }

  var elemeHeight = itemList.clientHeight;
  var timer;
  gutterHandler();
  window.addEventListener('resize', gutterHandler, false);

  function gutterHandler() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      itemList.style.paddingBottom = elemeHeight + 'px';
    }, 500);
  }
}

function InitTabsHeight() {
  var currentSection = document.querySelectorAll('.custom-tabs');

  if (!currentSection.length) {
    return;
  }

  var itemsArr = _toConsumableArray(currentSection);

  itemsArr.forEach(function (item) {
    var mainHolder = item;
    var elemeHeight = mainHolder.querySelector('.heading').clientHeight;
    var contentTabs = mainHolder.querySelector('.tab-content');
    var tabs = contentTabs.querySelectorAll('.text-col');
    var colImage = contentTabs.querySelectorAll('.centered .col-image');
    var maxTabsHeight = 0;
    var timer = null;
    var mdBreakPoint = 1024;
    heightHandler();
    window.addEventListener('resize', heightHandler, false);

    function heightHandler() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (window.innerWidth >= mdBreakPoint) {
          setTabsHeight();
          setColImageHeight();
        }
      }, 500);
    }

    function setTabsHeight() {
      for (var i = 0; i < tabs.length; i++) {
        if (maxTabsHeight < tabs[i].clientHeight) {
          maxTabsHeight = tabs[i].clientHeight;
        }
      }

      contentTabs.style.minHeight = maxTabsHeight + 'px';
    }

    function setColImageHeight() {
      for (var i = 0; i < colImage.length; i++) {
        colImage[i].style.marginTop = -elemeHeight + 'px';
        colImage[i].style.height = contentTabs.clientHeight + elemeHeight + 'px';
      }
    }
  });
}

function initInViewport() {
  jQuery('.viewport-section').itemInViewport({
    visibleMode: 2
  });
  jQuery('.viewport-section-full').itemInViewport({
    visibleMode: 1
  });
  jQuery('.viewport-section-always').itemInViewport({
    visibleMode: 2
  });
}
/*
 * jQuery In Viewport plugin
 */


(function ($, $win) {
  'use strict';

  var ScrollDetector = function () {
    var data = {};
    return {
      init: function init() {
        var self = this;
        this.addHolder('win', $win);
        $win.on('load.blockInViewport resize.blockInViewport orientationchange.blockInViewport', function () {
          $.each(data, function (holderKey, holderData) {
            self.calcHolderSize(holderData);
            $.each(holderData.items, function (itemKey, itemData) {
              self.calcItemSize(itemKey, itemData);
            });
          });
        });
      },
      addHolder: function addHolder(holderKey, $holder) {
        var self = this;
        var holderData = {
          holder: $holder,
          items: {},
          props: {
            height: 0,
            scroll: 0
          }
        };
        data[holderKey] = holderData;
        $holder.on('scroll.blockInViewport', function () {
          self.calcHolderScroll(holderData);
          $.each(holderData.items, function (itemKey, itemData) {
            self.calcItemScroll(itemKey, itemData);
          });
        });
        this.calcHolderSize(data[holderKey]);
      },
      calcHolderSize: function calcHolderSize(holderData) {
        var holderOffset = window.self !== holderData.holder[0] ? holderData.holder.offset() : 0;
        holderData.props.height = holderData.holder.get(0) === window ? window.innerHeight || document.documentElement.clientHeight : holderData.holder.outerHeight();
        holderData.props.offset = holderOffset ? holderOffset.top : 0;
        this.calcHolderScroll(holderData);
      },
      calcItemSize: function calcItemSize(itemKey, itemData) {
        itemData.offset = itemData.$el.offset().top - itemData.holderProps.props.offset;
        itemData.height = itemData.$el.outerHeight();
        this.calcItemScroll(itemKey, itemData);
      },
      calcHolderScroll: function calcHolderScroll(holderData) {
        holderData.props.scroll = holderData.holder.scrollTop();
      },
      calcItemScroll: function calcItemScroll(itemKey, itemData) {
        var itemInViewPortFromUp;
        var itemInViewPortFromDown;
        var itemOutViewPort;
        var holderProps = itemData.holderProps.props;

        switch (itemData.options.visibleMode) {
          case 1:
            itemInViewPortFromDown = itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + itemData.height < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemData.offset > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;

          case 2:
            itemInViewPortFromDown = itemInViewPortFromDown || itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + itemData.height / 2 < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemInViewPortFromUp || itemData.offset + itemData.height / 2 > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;

          case 3:
            itemInViewPortFromDown = itemInViewPortFromDown || itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemInViewPortFromUp || itemData.offset + itemData.height > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;

          default:
            itemInViewPortFromDown = itemInViewPortFromDown || itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + Math.min(itemData.options.visibleMode, itemData.height) < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemInViewPortFromUp || itemData.offset + itemData.height - Math.min(itemData.options.visibleMode, itemData.height) > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;
        }

        if (itemInViewPortFromUp && itemInViewPortFromDown) {
          if (!itemData.state) {
            itemData.state = true;
            itemData.$el.addClass(itemData.options.activeClass).trigger('in-viewport', true);

            if (itemData.options.once || $.isFunction(itemData.options.onShow) && itemData.options.onShow(itemData)) {
              delete itemData.holderProps.items[itemKey];
            }
          }
        } else {
          itemOutViewPort = itemData.offset < holderProps.scroll + holderProps.height && itemData.offset + itemData.height > holderProps.scroll;

          if ((itemData.state || isNaN(itemData.state)) && !itemOutViewPort) {
            itemData.state = false;
            itemData.$el.removeClass(itemData.options.activeClass).trigger('in-viewport', false);
          }
        }
      },
      addItem: function addItem(el, options) {
        var itemKey = 'item' + this.getRandomValue();
        var newItem = {
          $el: $(el),
          options: options
        };
        var holderKeyDataName = 'in-viewport-holder';
        var $holder = newItem.$el.closest(options.holder);
        var holderKey = $holder.data(holderKeyDataName);

        if (!$holder.length) {
          holderKey = 'win';
        } else if (!holderKey) {
          holderKey = 'holder' + this.getRandomValue();
          $holder.data(holderKeyDataName, holderKey);
          this.addHolder(holderKey, $holder);
        }

        newItem.holderProps = data[holderKey];
        data[holderKey].items[itemKey] = newItem;
        this.calcItemSize(itemKey, newItem);
      },
      getRandomValue: function getRandomValue() {
        return (Math.random() * 100000).toFixed(0);
      },
      destroy: function destroy() {
        $win.off('.blockInViewport');
        $.each(data, function (key, value) {
          value.holder.off('.blockInViewport');
          $.each(value.items, function (key, value) {
            value.$el.removeClass(value.options.activeClass);
            value.$el.get(0).itemInViewportAdded = null;
          });
        });
        data = {};
      }
    };
  }();

  ScrollDetector.init();

  $.fn.itemInViewport = function (options) {
    options = $.extend({
      activeClass: 'in-viewport',
      once: true,
      holder: '',
      visibleMode: 1 // 1 - full block, 2 - half block, 3 - immediate, 4... - custom

    }, options);
    return this.each(function () {
      if (this.itemInViewportAdded) {
        return;
      }

      this.itemInViewportAdded = true;
      ScrollDetector.addItem(this, options);
    });
  };
})(jQuery, jQuery(window));

$(function () {
  // $(document).ready(() => {
  //   setTimeout(function() {
  //     updateExplainSection();
  //     // updateValueProposition();
  //   }, 1000);
  // });
  // $(window).resize(() => {
  //   updateExplainSection();
  //   updateValueProposition();
  // });
  //workaround to align the height of the description in explain-section's tiles with the position of the longest/highest title
  // const updateExplainSection = () => {
  //   if ($(document).width() > 767) {
  //     let initHeight = 0;
  //     $('.explain-section').each((_, el) => {
  //       initHeight = 0;
  //       $(el)
  //         .find('.content-box')
  //         .each((_, box) => {
  //           initHeight =
  //             $(box)
  //               .find('h3')
  //               .height() > initHeight
  //               ? $(box)
  //                   .find('h3')
  //                   .height()
  //               : initHeight;
  //         });
  //       $(el)
  //         .find('.content-box')
  //         .find('h3')
  //         .height(initHeight);
  //     });
  //   }
  // };
  //workaround to align the padding bottom of Value proposition section boxes in cases where one of the Metric descriptions has more rows then the other
  // const updateValueProposition = () => {
  //   if ($(document).width() >= 1440 || $(document).width() < 1200) {
  //     $('.info-boxes').each((_, el) => {
  //       let initPadding = 32;
  //       $(el)
  //         .find('.info-box')
  //         .each((_, box) => {
  //           initPadding =
  //             $(box)
  //               .find('.text')
  //               .height() > initPadding
  //               ? $(box)
  //                   .find('.text')
  //                   .height()
  //               : initPadding;
  //         });
  //       const $infoBoxElem = $(el).find('.info-box');
  //       $infoBoxElem.find('.text').height(initPadding);
  //       if (
  //         $(document).width() >= 1440 ||
  //         (initPadding > 62 && $(document).width() <= 1024)
  //       ) {
  //         $infoBoxElem
  //           .find('hr')
  //           .css(
  //             'bottom',
  //             parseInt($infoBoxElem.find('hr').css('bottom'), 10) + 32 + 'px'
  //           );
  //       }
  //     });
  //   }
  // };
  var $faqsCollapse = $('.faqs-collapse');
  $faqsCollapse.on('show.bs.collapse', function (_ref) {
    var currentTarget = _ref.currentTarget;
    $(currentTarget).parent('.box').addClass('box-open').removeClass('box-close');
  });
  $faqsCollapse.on('hide.bs.collapse', function (_ref2) {
    var currentTarget = _ref2.currentTarget;
    $(currentTarget).parent('.box').addClass('box-close').removeClass('box-open');
  });
  $('.db-listing-section .show-all-btn').on('click', function (_ref3) {
    var currentTarget = _ref3.currentTarget;
    $('.db-listing-section .box').parent().show();
    $(currentTarget).hide();
  });
});
document.addEventListener('DOMContentLoaded', function () {
  initPossibleDotted(); // DC: this only works when called here

  jQuery('.dotted').dotdotdot({
    ellipsis: "\u2026 ",
    height: null,
    keep: '.read-more',
    tolerance: 0,
    truncate: 'word',
    watch: 'true'
  });
});

(function (root, factory) {
  // if (typeof define === 'function' && define.amd) {
  // 	define(['jquery'], factory);
  // } else if (typeof exports === 'object') {
  // 	module.exports = factory(require('jquery'));
  // } else {
  // 	root.jquery_dotdotdot_js = factory(root.jQuery);
  // }
  factory(jQuery);
})(void 0, function (jQuery) {
  /*
   *	jQuery dotdotdot 3.2.2
   *	@requires jQuery 1.7.0 or later
   *
   *	dotdotdot.frebsite.nl
   *
   *	Copyright (c) Fred Heusschen
   *	www.frebsite.nl
   *
   *	License: CC-BY-NC-4.0
   *	http://creativecommons.org/licenses/by-nc/4.0/
   */
  !function (t) {
    'use strict';

    function e() {
      h = t(window), s = {}, o = {}, r = {}, t.each([s, o, r], function (t, e) {
        e.add = function (t) {
          t = t.split(' ');

          for (var i = 0, n = t.length; i < n; i++) {
            e[t[i]] = e.ddd(t[i]);
          }
        };
      }), s.ddd = function (t) {
        return 'ddd-' + t;
      }, s.add('truncated keep'), o.ddd = function (t) {
        return 'ddd-' + t;
      }, r.ddd = function (t) {
        return t + '.ddd';
      }, r.add('resize'), e = function e() {};
    }

    var i = 'dotdotdot',
        n = '3.2.2';

    if (!(t[i] && t[i].version > n)) {
      t[i] = function (t, e) {
        this.$dot = t, this.api = ['getInstance', 'truncate', 'restore', 'destroy', 'watch', 'unwatch'], this.opts = e;
        var n = this.$dot.data(i);
        return n && n.destroy(), this.init(), this.truncate(), this.opts.watch && this.watch(), this;
      }, t[i].version = n, t[i].uniqueId = 0, t[i].defaults = {
        ellipsis: '… ',
        callback: function callback(t) {},
        truncate: 'word',
        tolerance: 0,
        keep: null,
        watch: 'window',
        height: null
      }, t[i].prototype = {
        init: function init() {
          this.watchTimeout = null, this.watchInterval = null, this.uniqueId = t[i].uniqueId++, this.originalStyle = this.$dot.attr('style') || '', this.originalContent = this._getOriginalContent(), 'break-word' !== this.$dot.css('word-wrap') && this.$dot.css('word-wrap', 'break-word'), 'nowrap' === this.$dot.css('white-space') && this.$dot.css('white-space', 'normal'), null === this.opts.height && (this.opts.height = this._getMaxHeight()), 'string' == typeof this.opts.ellipsis && (this.opts.ellipsis = document.createTextNode(this.opts.ellipsis));
        },
        getInstance: function getInstance() {
          return this;
        },
        truncate: function truncate() {
          this.$inner = this.$dot.wrapInner('<div />').children().css({
            display: 'block',
            height: 'auto',
            width: 'auto',
            border: 'none',
            padding: 0,
            margin: 0
          }), this.$inner.empty().append(this.originalContent.clone(!0)), this.maxHeight = this._getMaxHeight();
          var t = !1;
          return this._fits() || (t = !0, this._truncateToNode(this.$inner[0])), this.$dot[t ? 'addClass' : 'removeClass'](s.truncated), this.$inner.replaceWith(this.$inner.contents()), this.$inner = null, this.opts.callback.call(this.$dot[0], t), t;
        },
        restore: function restore() {
          this.unwatch(), this.$dot.empty().append(this.originalContent).attr('style', this.originalStyle).removeClass(s.truncated);
        },
        destroy: function destroy() {
          this.restore(), this.$dot.data(i, null);
        },
        watch: function watch() {
          var t = this;
          this.unwatch();
          var e = {};
          'window' == this.opts.watch ? h.on(r.resize + t.uniqueId, function (i) {
            t.watchTimeout && clearTimeout(t.watchTimeout), t.watchTimeout = setTimeout(function () {
              e = t._watchSizes(e, h, 'width', 'height');
            }, 100);
          }) : this.watchInterval = setInterval(function () {
            e = t._watchSizes(e, t.$dot, 'innerWidth', 'innerHeight');
          }, 500);
        },
        unwatch: function unwatch() {
          h.off(r.resize + this.uniqueId), this.watchInterval && clearInterval(this.watchInterval), this.watchTimeout && clearTimeout(this.watchTimeout);
        },
        _api: function _api() {
          var e = this,
              i = {};
          return t.each(this.api, function (t) {
            var n = this;

            i[n] = function () {
              var t = e[n].apply(e, arguments);
              return 'undefined' == typeof t ? i : t;
            };
          }), i;
        },
        _truncateToNode: function _truncateToNode(e) {
          var i = [],
              n = [];

          if (t(e).contents().each(function () {
            var e = t(this);

            if (!e.hasClass(s.keep)) {
              var o = document.createComment('');
              e.replaceWith(o), n.push(this), i.push(o);
            }
          }), n.length) {
            for (var o = 0; o < n.length; o++) {
              t(i[o]).replaceWith(n[o]), t(n[o]).append(this.opts.ellipsis);

              var r = this._fits();

              if (t(this.opts.ellipsis, n[o]).remove(), !r) {
                if ('node' == this.opts.truncate && o > 1) return void t(n[o - 2]).remove();
                break;
              }
            }

            for (var h = o; h < i.length; h++) {
              t(i[h]).remove();
            }

            var a = n[Math.max(0, Math.min(o, n.length - 1))];

            if (1 == a.nodeType) {
              var d = t('<' + a.nodeName + ' />');
              d.append(this.opts.ellipsis), t(a).replaceWith(d), this._fits() ? d.replaceWith(a) : (d.remove(), a = n[Math.max(0, o - 1)]);
            }

            1 == a.nodeType ? this._truncateToNode(a) : this._truncateToWord(a);
          }
        },
        _truncateToWord: function _truncateToWord(t) {
          for (var e = t, i = this, n = this.__getTextContent(e), s = n.indexOf(' ') !== -1 ? ' ' : '　', o = n.split(s), r = '', h = o.length; h >= 0; h--) {
            if (r = o.slice(0, h).join(s), i.__setTextContent(e, i._addEllipsis(r)), i._fits()) {
              'letter' == i.opts.truncate && (i.__setTextContent(e, o.slice(0, h + 1).join(s)), i._truncateToLetter(e));
              break;
            }
          }
        },
        _truncateToLetter: function _truncateToLetter(t) {
          for (var e = this, i = this.__getTextContent(t), n = i.split(''), s = '', o = n.length; o >= 0 && (s = n.slice(0, o).join(''), !s.length || (e.__setTextContent(t, e._addEllipsis(s)), !e._fits())); o--) {
            ;
          }
        },
        _fits: function _fits() {
          return this.$inner.innerHeight() <= this.maxHeight + this.opts.tolerance;
        },
        _addEllipsis: function _addEllipsis(e) {
          for (var i = [' ', '　', ',', ';', '.', '!', '?']; t.inArray(e.slice(-1), i) > -1;) {
            e = e.slice(0, -1);
          }

          return e += this.__getTextContent(this.opts.ellipsis);
        },
        _getOriginalContent: function _getOriginalContent() {
          var e = this;
          return this.$dot.find('script, style').addClass(s.keep), this.opts.keep && this.$dot.find(this.opts.keep).addClass(s.keep), this.$dot.find('*').not('.' + s.keep).add(this.$dot).contents().each(function () {
            var i = this,
                n = t(this);

            if (3 == i.nodeType) {
              if ('' == t.trim(e.__getTextContent(i))) {
                if (n.parent().is('table, thead, tbody, tfoot, tr, dl, ul, ol, video')) return void n.remove();
                if (n.prev().is('div, p, table, td, td, dt, dd, li')) return void n.remove();
                if (n.next().is('div, p, table, td, td, dt, dd, li')) return void n.remove();
                if (!n.prev().length) return void n.remove();
                if (!n.next().length) return void n.remove();
              }
            } else 8 == i.nodeType && n.remove();
          }), this.$dot.contents();
        },
        _getMaxHeight: function _getMaxHeight() {
          if ('number' == typeof this.opts.height) return this.opts.height;

          for (var t = ['maxHeight', 'height'], e = 0, i = 0; i < t.length; i++) {
            if (e = window.getComputedStyle(this.$dot[0])[t[i]], 'px' == e.slice(-2)) {
              e = parseFloat(e);
              break;
            }
          }

          var t = [];

          switch (this.$dot.css('boxSizing')) {
            case 'border-box':
              t.push('borderTopWidth'), t.push('borderBottomWidth');

            case 'padding-box':
              t.push('paddingTop'), t.push('paddingBottom');
          }

          for (var i = 0; i < t.length; i++) {
            var n = window.getComputedStyle(this.$dot[0])[t[i]];
            'px' == n.slice(-2) && (e -= parseFloat(n));
          }

          return Math.max(e, 0);
        },
        _watchSizes: function _watchSizes(t, e, i, n) {
          if (this.$dot.is(':visible')) {
            var s = {
              width: e[i](),
              height: e[n]()
            };
            return t.width == s.width && t.height == s.height || this.truncate(), s;
          }

          return t;
        },
        __getTextContent: function __getTextContent(t) {
          for (var e = ['nodeValue', 'textContent', 'innerText'], i = 0; i < e.length; i++) {
            if ('string' == typeof t[e[i]]) return t[e[i]];
          }

          return '';
        },
        __setTextContent: function __setTextContent(t, e) {
          for (var i = ['nodeValue', 'textContent', 'innerText'], n = 0; n < i.length; n++) {
            t[i[n]] = e;
          }
        }
      }, t.fn[i] = function (n) {
        return e(), n = t.extend(!0, {}, t[i].defaults, n), this.each(function () {
          t(this).data(i, new t[i](t(this), n)._api());
        });
      };
      var s, o, r, h;
    }
  }(jQuery);
  return true;
});
/*
 * jQuery SameHeight plugin
 */


(function ($) {
  $.fn.sameHeight = function (opt) {
    var options = $.extend({
      skipClass: 'same-height-ignore',
      leftEdgeClass: 'same-height-left',
      rightEdgeClass: 'same-height-right',
      elements: '>*',
      flexible: false,
      multiLine: false,
      useMinHeight: false,
      biggestHeight: false
    }, opt);
    return this.each(function () {
      var holder = $(this),
          postResizeTimer,
          ignoreResize;
      var elements = holder.find(options.elements).not('.' + options.skipClass);
      if (!elements.length) return; // resize handler

      function doResize() {
        elements.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', '');

        if (options.multiLine) {
          // resize elements row by row
          resizeElementsByRows(elements, options);
        } else {
          // resize elements by holder
          resizeElements(elements, holder, options);
        }
      }

      doResize(); // handle flexible layout / font resize

      var delayedResizeHandler = function delayedResizeHandler() {
        if (!ignoreResize) {
          ignoreResize = true;
          doResize();
          clearTimeout(postResizeTimer);
          postResizeTimer = setTimeout(function () {
            doResize();
            setTimeout(function () {
              ignoreResize = false;
            }, 10);
          }, 100);
        }
      }; // handle flexible/responsive layout


      if (options.flexible) {
        $(window).bind('resize orientationchange fontresize', delayedResizeHandler);
      } // handle complete page load including images and fonts


      $(window).bind('load', delayedResizeHandler);
    });
  }; // detect css min-height support


  var supportMinHeight = typeof document.documentElement.style.maxHeight !== 'undefined'; // get elements by rows

  function resizeElementsByRows(boxes, options) {
    var currentRow = $(),
        maxHeight,
        maxCalcHeight = 0,
        firstOffset = boxes.eq(0).offset().top;
    boxes.each(function (ind) {
      var curItem = $(this);

      if (curItem.offset().top === firstOffset) {
        currentRow = currentRow.add(this);
      } else {
        maxHeight = getMaxHeight(currentRow);
        maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
        currentRow = curItem;
        firstOffset = curItem.offset().top;
      }
    });

    if (currentRow.length) {
      maxHeight = getMaxHeight(currentRow);
      maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
    }

    if (options.biggestHeight) {
      boxes.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', maxCalcHeight);
    }
  } // calculate max element height


  function getMaxHeight(boxes) {
    var maxHeight = 0;
    boxes.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });
    return maxHeight;
  } // resize helper function


  function resizeElements(boxes, parent, options) {
    var calcHeight;
    var parentHeight = typeof parent === 'number' ? parent : parent.height();
    boxes.removeClass(options.leftEdgeClass).removeClass(options.rightEdgeClass).each(function (i) {
      var element = $(this);
      var depthDiffHeight = 0;
      var isBorderBox = element.css('boxSizing') === 'border-box' || element.css('-moz-box-sizing') === 'border-box' || element.css('-webkit-box-sizing') === 'border-box';

      if (typeof parent !== 'number') {
        element.parents().each(function () {
          var tmpParent = $(this);

          if (parent.is(this)) {
            return false;
          } else {
            depthDiffHeight += tmpParent.outerHeight() - tmpParent.height();
          }
        });
      }

      calcHeight = parentHeight - depthDiffHeight;
      calcHeight -= isBorderBox ? 0 : element.outerHeight() - element.height();

      if (calcHeight > 0) {
        element.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', calcHeight);
      }
    });
    boxes.filter(':first').addClass(options.leftEdgeClass);
    boxes.filter(':last').addClass(options.rightEdgeClass);
    return calcHeight;
  }
})(jQuery);
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/
 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues
 */


(function (i) {
  'use strict';

  'function' == typeof define && define.amd ? define(['jquery'], i) : 'undefined' != typeof exports ? module.exports = i((typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)) : i(jQuery);
})(function (i) {
  'use strict';

  var e = window.Slick || {};
  e = function () {
    function e(e, o) {
      var s,
          n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(e),
        appendDots: i(e),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: 'slick-dots',
        draggable: !0,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = 'hidden', n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = 'visibilitychange', n.windowWidth = 0, n.windowTimer = null, s = i(e).data('slick') || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, 'undefined' != typeof document.mozHidden ? (n.hidden = 'mozHidden', n.visibilityChange = 'mozvisibilitychange') : 'undefined' != typeof document.webkitHidden && (n.hidden = 'webkitHidden', n.visibilityChange = 'webkitvisibilitychange'), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = t++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    }

    var t = 0;
    return e;
  }(), e.prototype.activateADA = function () {
    var i = this;
    i.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      tabindex: '0'
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ('boolean' == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), 'number' == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
        s = this;
    s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), s.options.vertical === !1 ? (o[s.animType] = 'translate(' + i + 'px, 0px)', s.$slideTrack.css(o)) : (o[s.animType] = 'translate(0px,' + i + 'px)', s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = 'translate3d(' + e + 'px, 0px, 0px)' : o[s.animType] = 'translate3d(0px,' + e + 'px, 0px)', s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
        t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this,
        o = t.getNavTarget();
    null !== o && 'object' == _typeof(o) && o.each(function () {
      var t = i(this).slick('getSlick');
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
        t = {};
    e.options.fade === !1 ? t[e.transitionType] = e.transformType + ' ' + e.options.speed + 'ms ' + e.options.cssEase : t[e.transitionType] = 'opacity ' + e.options.speed + 'ms ' + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (i.options.infinite === !1 && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    e.options.arrows === !0 && (e.$prevArrow = i(e.options.prevArrow).addClass('slick-arrow'), e.$nextArrow = i(e.options.nextArrow).addClass('slick-arrow'), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true')) : e.$prevArrow.add(e.$nextArrow).addClass('slick-hidden').attr({
      'aria-disabled': 'true',
      tabindex: '-1'
    }));
  }, e.prototype.buildDots = function () {
    var e,
        t,
        o = this;

    if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
      for (o.$slider.addClass('slick-dotted'), t = i('<ul />').addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
        t.append(i('<li />').append(o.options.customPaging.call(this, o, e)));
      }

      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find('li').first().addClass('slick-active');
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ':not(.slick-cloned)').addClass('slick-slide'), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e).data('originalStyling', i(t).attr('style') || '');
    }), e.$slider.addClass('slick-slider'), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css('opacity', 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), i('img[data-lazy]', e.$slider).not('[src]').addClass('slick-loading'), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass('draggable');
  }, e.prototype.buildRows = function () {
    var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;

    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 0) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement('div');

        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement('div');

          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }

          d.appendChild(a);
        }

        o.appendChild(d);
      }

      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + '%',
        display: 'inline-block'
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();

    if ('window' === r.respondTo ? n = a : 'slider' === r.respondTo ? n = d : 'min' === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;

      for (o in r.breakpoints) {
        r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      }

      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || l === !1 || r.$slider.trigger('breakpoint', [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);

    switch (l.is('a') && e.preventDefault(), l.is('li') || (l = l.closest('li')), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case 'previous':
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;

      case 'next':
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;

      case 'index':
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger('focus');
        break;

      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e,
        t,
        o = this;
    if (e = o.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var s in e) {
      if (i < e[s]) {
        i = t;
        break;
      }

      t = e[s];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i('li', e.$dots).off('click.slick', e.changeSlide).off('mouseenter.slick', i.proxy(e.interrupt, e, !0)).off('mouseleave.slick', i.proxy(e.interrupt, e, !1)), e.options.accessibility === !0 && e.$dots.off('keydown.slick', e.keyHandler)), e.$slider.off('focus.slick blur.slick'), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off('click.slick', e.changeSlide), e.$nextArrow && e.$nextArrow.off('click.slick', e.changeSlide), e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off('keydown.slick', e.keyHandler), e.$nextArrow && e.$nextArrow.off('keydown.slick', e.keyHandler))), e.$list.off('touchstart.slick mousedown.slick', e.swipeHandler), e.$list.off('touchmove.slick mousemove.slick', e.swipeHandler), e.$list.off('touchend.slick mouseup.slick', e.swipeHandler), e.$list.off('touchcancel.slick mouseleave.slick', e.swipeHandler), e.$list.off('click.slick', e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off('click.slick', e.selectHandler), i(window).off('orientationchange.slick.slick-' + e.instanceUid, e.orientationChange), i(window).off('resize.slick.slick-' + e.instanceUid, e.resize), i('[draggable!=true]', e.$slideTrack).off('dragstart', e.preventDefault), i(window).off('load.slick.slick-' + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.off('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
        e = this;
    e.options.rows > 0 && (i = e.$slides.children().children(), i.removeAttr('style'), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    var e = this;
    e.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i('.slick-cloned', t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
      i(this).attr('style', i(this).data('originalStyling'));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass('slick-slider'), t.$slider.removeClass('slick-initialized'), t.$slider.removeClass('slick-dotted'), t.unslicked = !0, e || t.$slider.trigger('destroy', [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
        t = {};
    t[e.transitionType] = '', e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    t.cssTransitions === !1 ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    e.cssTransitions === !1 ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (t) {
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && o.is(':focus') && (e.focussed = !0, e.autoPlay());
      }, 0);
    }).on('blur.slick', '*', function (t) {
      i(this);
      e.options.pauseOnFocus && (e.focussed = !1, e.autoPlay());
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    var i = this;
    return i.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
        e = 0,
        t = 0,
        o = 0;
    if (i.options.infinite === !0) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) {
        ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      }
    } else if (i.options.centerMode === !0) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
      ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
        t,
        o,
        s,
        n = this,
        r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, n.options.vertical === !0 && n.options.centerMode === !0 && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll !== 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, n.options.variableWidth === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, n.options.centerMode === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow + 1), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    var e = this;
    return e.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
        e = this,
        t = 0,
        o = 0,
        s = [];

    for (e.options.infinite === !1 ? i = e.slideCount : (t = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, i = 2 * e.slideCount); t < i;) {
      s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    }

    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
        t,
        o,
        s,
        n = this;
    return s = n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0, o = n.swipeLeft * -1 + s, n.options.swipeToSlide === !0 ? (n.$slideTrack.find('.slick-slide').each(function (e, s) {
      var r, l, d;
      if (r = i(s).outerWidth(), l = s.offsetLeft, n.options.centerMode !== !0 && (l += r / 2), d = l + r, o < d) return t = s, !1;
    }), e = Math.abs(i(t).attr('data-slick-index') - n.currentSlide) || 1) : n.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    var t = this;
    t.changeSlide({
      data: {
        message: 'index',
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass('slick-initialized') || (i(t.$slider).addClass('slick-initialized'), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger('init', [t]), t.options.accessibility === !0 && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
      return i >= 0 && i < e.slideCount;
    });
    e.$slides.add(e.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      tabindex: '-1'
    }).find('a, input, button, select').attr({
      tabindex: '-1'
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find('.slick-cloned')).each(function (t) {
      var s = o.indexOf(t);

      if (i(this).attr({
        role: 'tabpanel',
        id: 'slick-slide' + e.instanceUid + t,
        tabindex: -1
      }), s !== -1) {
        var n = 'slick-slide-control' + e.instanceUid + s;
        i('#' + n).length && i(this).attr({
          'aria-describedby': n
        });
      }
    }), e.$dots.attr('role', 'tablist').find('li').each(function (s) {
      var n = o[s];
      i(this).attr({
        role: 'presentation'
      }), i(this).find('button').first().attr({
        role: 'tab',
        id: 'slick-slide-control' + e.instanceUid + s,
        'aria-controls': 'slick-slide' + e.instanceUid + n,
        'aria-label': s + 1 + ' of ' + t,
        'aria-selected': null,
        tabindex: '-1'
      });
    }).eq(e.currentSlide).find('button').attr({
      'aria-selected': 'true',
      tabindex: '0'
    }).end());

    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) {
      e.options.focusOnChange ? e.$slides.eq(s).attr({
        tabindex: '0'
      }) : e.$slides.eq(s).removeAttr('tabindex');
    }

    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off('click.slick').on('click.slick', {
      message: 'previous'
    }, i.changeSlide), i.$nextArrow.off('click.slick').on('click.slick', {
      message: 'next'
    }, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on('keydown.slick', i.keyHandler), i.$nextArrow.on('keydown.slick', i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (i('li', e.$dots).on('click.slick', {
      message: 'index'
    }, e.changeSlide), e.options.accessibility === !0 && e.$dots.on('keydown.slick', e.keyHandler)), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && i('li', e.$dots).on('mouseenter.slick', i.proxy(e.interrupt, e, !0)).on('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.on('mouseleave.slick', i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, e.swipeHandler), e.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, e.swipeHandler), e.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('click.slick', e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), i(window).on('orientationchange.slick.slick-' + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on('resize.slick.slick-' + e.instanceUid, i.proxy(e.resize, e)), i('[draggable!=true]', e.$slideTrack).on('dragstart', e.preventDefault), i(window).on('load.slick.slick-' + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match('TEXTAREA|INPUT|SELECT') || (37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'next' : 'previous'
      }
    }) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'previous' : 'next'
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i('img[data-lazy]', e).each(function () {
        var e = i(this),
            t = i(this).attr('data-lazy'),
            o = i(this).attr('data-srcset'),
            s = i(this).attr('data-sizes') || r.$slider.attr('data-sizes'),
            n = document.createElement('img');
        n.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr('srcset', o), s && e.attr('sizes', s)), e.attr('src', t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            }), r.$slider.trigger('lazyLoaded', [r, e, t]);
          });
        }, n.onerror = function () {
          e.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), r.$slider.trigger('lazyLoadError', [r, e, t]);
        }, n.src = t;
      });
    }

    var t,
        o,
        s,
        n,
        r = this;
    if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), t = r.$slider.find('.slick-slide').slice(s, n), 'anticipated' === r.options.lazyLoad) for (var l = s - 1, d = n, a = r.$slider.find('.slick-slide'), c = 0; c < r.options.slidesToScroll; c++) {
      l < 0 && (l = r.slideCount - 1), t = t.add(a.eq(l)), t = t.add(a.eq(d)), l--, d++;
    }
    e(t), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find('.slick-slide'), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find('.slick-cloned').slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find('.slick-cloned').slice(r.options.slidesToShow * -1), e(o));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass('slick-loading'), i.initUI(), 'progressive' === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'next'
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;

    if (!t.unslicked && (t.$slider.trigger('afterChange', [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && (t.initADA(), t.options.focusOnChange))) {
      var o = i(t.$slides.get(t.currentSlide));
      o.attr('tabindex', 0).focus();
    }
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'previous'
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i('img[data-lazy]', l.$slider);
    d.length ? (t = d.first(), o = t.attr('data-lazy'), s = t.attr('data-srcset'), n = t.attr('data-sizes') || l.$slider.attr('data-sizes'), r = document.createElement('img'), r.onload = function () {
      s && (t.attr('srcset', s), n && t.attr('sizes', n)), t.attr('src', o).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading'), l.options.adaptiveHeight === !0 && l.setPosition(), l.$slider.trigger('lazyLoaded', [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), l.$slider.trigger('lazyLoadError', [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger('allImagesLoaded', [l]);
  }, e.prototype.refresh = function (e) {
    var t,
        o,
        s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: 'index',
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;

    if ('array' === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || 'window';

      for (e in n) {
        if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
          for (t = n[e].breakpoint; o >= 0;) {
            s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
          }

          s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
        }
      }

      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass('slick-slide'), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger('reInit', [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    return 'boolean' == typeof i ? (e = i, i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i, !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) && (o.unload(), t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit());
  }, e.prototype.setCSS = function (i) {
    var e,
        t,
        o = this,
        s = {};
    o.options.rtl === !0 && (i = -i), e = 'left' == o.positionProp ? Math.ceil(i) + 'px' : '0px', t = 'top' == o.positionProp ? Math.ceil(i) + 'px' : '0px', s[o.positionProp] = i, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = 'translate(' + e + ', ' + t + ')', o.$slideTrack.css(s)) : (s[o.animType] = 'translate3d(' + e + ', ' + t + ', 0px)', o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
      padding: '0px ' + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({
      padding: i.options.centerPadding + ' 0px'
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children('.slick-slide').length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children('.slick-slide').length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    i.options.variableWidth === !1 && i.$slideTrack.children('.slick-slide').width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
        t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, t.options.rtl === !0 ? i(s).css({
        position: 'relative',
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: 'relative',
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css('height', e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
    if ('object' === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = 'multiple') : 'string' === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], 'responsive' === arguments[0] && 'array' === i.type(arguments[1]) ? n = 'responsive' : 'undefined' != typeof arguments[1] && (n = 'single')), 'single' === n) r.options[o] = s;else if ('multiple' === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ('responsive' === n) for (t in s) {
      if ('array' !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
        for (e = r.options.responsive.length - 1; e >= 0;) {
          r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
        }

        r.options.responsive.push(s[t]);
      }
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger('setPosition', [i]);
  }, e.prototype.setProps = function () {
    var i = this,
        e = document.body.style;
    i.positionProp = i.options.vertical === !0 ? 'top' : 'left', 'top' === i.positionProp ? i.$slider.addClass('slick-vertical') : i.$slider.removeClass('slick-vertical'), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && ('number' == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = 'OTransform', i.transformType = '-o-transform', i.transitionType = 'OTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = 'MozTransform', i.transformType = '-moz-transform', i.transitionType = 'MozTransition', void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = 'webkitTransform', i.transformType = '-webkit-transform', i.transitionType = 'webkitTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = 'msTransform', i.transformType = '-ms-transform', i.transitionType = 'msTransition', void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && i.animType !== !1 && (i.animType = 'transform', i.transformType = 'transform', i.transitionType = 'transition'), i.transformsEnabled = i.options.useTransform && null !== i.animType && i.animType !== !1;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
        t,
        o,
        s,
        n = this;

    if (t = n.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true'), n.$slides.eq(i).addClass('slick-current'), n.options.centerMode === !0) {
      var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass('slick-active').attr('aria-hidden', 'false') : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass('slick-active').attr('aria-hidden', 'false')), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass('slick-center') : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass('slick-center')), n.$slides.eq(i).addClass('slick-center');
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false') : t.length <= n.options.slidesToShow ? t.addClass('slick-active').attr('aria-hidden', 'false') : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass('slick-active').attr('aria-hidden', 'false') : t.slice(o, o + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false'));

    'ondemand' !== n.options.lazyLoad && 'anticipated' !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
        t,
        o,
        s = this;

    if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
        t = e - 1, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t - s.slideCount).prependTo(s.$slideTrack).addClass('slick-cloned');
      }

      for (e = 0; e < o + s.slideCount; e += 1) {
        t = e, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t + s.slideCount).appendTo(s.$slideTrack).addClass('slick-cloned');
      }

      s.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
        i(this).attr('id', '');
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
        o = i(e.target).is('.slick-slide') ? i(e.target) : i(e.target).parents('.slick-slide'),
        s = parseInt(o.attr('data-slick-index'));
    return s || (s = 0), t.slideCount <= t.options.slidesToShow ? void t.slideHandler(s, !1, !0) : void t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
    if (e = e || !1, !(a.animating === !0 && a.options.waitForAnimate === !0 || a.options.fade === !0 && a.currentSlide === i)) return e === !1 && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, a.options.infinite === !1 && a.options.centerMode === !1 && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : a.options.infinite === !1 && a.options.centerMode === !0 && (i < 0 || i > a.slideCount - a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll !== 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll !== 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger('beforeChange', [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = a.getNavTarget(), l = l.slick('getSlick'), l.slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide)), a.updateDots(), a.updateArrows(), a.options.fade === !0 ? (t !== !0 ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
      a.postSlide(s);
    })) : a.postSlide(s), void a.animateHeight()) : void (t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(d, function () {
      a.postSlide(s);
    }) : a.postSlide(s)));
  }, e.prototype.startLoad = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass('slick-loading');
  }, e.prototype.swipeDirection = function () {
    var i,
        e,
        t,
        o,
        s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), o = Math.round(180 * t / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? 'left' : 'right' : o <= 360 && o >= 315 ? s.options.rtl === !1 ? 'left' : 'right' : o >= 135 && o <= 225 ? s.options.rtl === !1 ? 'right' : 'left' : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? 'down' : 'up' : 'vertical';
  }, e.prototype.swipeEnd = function (i) {
    var e,
        t,
        o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;

    if (o.touchObject.edgeHit === !0 && o.$slider.trigger('edge', [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case 'left':
        case 'down':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }

      'vertical' != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger('swipe', [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(e.options.swipe === !1 || 'ontouchend' in document && e.options.swipe === !1 || e.options.draggable === !1 && i.type.indexOf('mouse') !== -1)) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case 'start':
        e.swipeStart(i);
        break;

      case 'move':
        e.swipeMove(i);
        break;

      case 'end':
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (l.options.verticalSwiping === !0 && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), l.options.verticalSwiping === !0 && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, l.options.infinite === !1 && (0 === l.currentSlide && 'right' === t || l.currentSlide >= l.getDotCount() && 'left' === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s), l.options.fade !== !0 && l.options.touchMove !== !1 && (l.animating === !0 ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
        t = this;
    return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {}, !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void (t.dragging = !0));
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i('.slick-cloned', e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger('unslick', [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i,
        e = this;
    i = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), 0 === e.currentSlide ? (e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find('li').removeClass('slick-active').end(), i.$dots.find('li').eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass('slick-active'));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;

    for (i = 0; i < r; i++) {
      if ('object' == _typeof(s) || 'undefined' == typeof s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), 'undefined' != typeof t) return t;
    }

    return o;
  };
});
/*
 * Mobile hover plugin
 */


(function ($) {
  var doc = jQuery(document); // detect device type

  var isTouchDevice = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
      isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent); // define events

  var eventOn = isTouchDevice && 'touchstart' || isWinPhoneDevice && navigator.pointerEnabled && 'pointerdown' || isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerDown' || 'mouseenter',
      eventOff = isTouchDevice && 'touchend' || isWinPhoneDevice && navigator.pointerEnabled && 'pointerup' || isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerUp' || 'mouseleave';
  isTouchDevice = /Windows Phone/.test(navigator.userAgent) || 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

  function toggleClass(opt, e) {
    var el = jQuery(e.currentTarget);

    if (!isTouchDevice) {
      el.one(eventOff, function () {
        jQuery(this).removeClass(opt.hoverClass);
      });
    } else {
      if (!el.hasClass(opt.hoverClass)) {
        jQuery(this).off('click.hover', function (e) {
          e.preventDefault();
        });
        setTimeout(function () {
          doc.on(eventOn + '.hover', function (e) {
            var target = jQuery(e.target);

            if (!target.is(el) && !target.closest(el).length) {
              el.removeClass(opt.hoverClass);
              jQuery(this).off('click.hover');
              doc.off(eventOn + '.hover');
            }
          });
        });
      }
    }

    if (!el.hasClass(opt.hoverClass)) {
      if (e) e.preventDefault();
      el.addClass(opt.hoverClass);
    }
  } // jQuery plugin


  $.fn.touchHover = function (opt) {
    var options = $.extend({
      hoverClass: 'hover'
    }, opt);
    this.on(eventOn, toggleClass.bind(this, options));
    return this;
  };
})(jQuery);
/*
 * Add class plugin
 */


jQuery.fn.clickClass = function (opt) {
  var options = jQuery.extend({
    classAdd: 'add-class',
    addToParent: false,
    event: 'click'
  }, opt);
  return this.each(function () {
    var classItem = jQuery(this);

    if (options.addToParent) {
      if (typeof options.addToParent === 'boolean') {
        classItem = classItem.parent();
      } else {
        classItem = classItem.parents('.' + options.addToParent);
      }
    }

    jQuery(this).bind(options.event, function (e) {
      classItem.toggleClass(options.classAdd);
      e.preventDefault();
    });
  });
};
/*
 * jQuery sticky box plugin
 */


(function ($, $win) {
  'use strict';

  function StickyScrollBlock($stickyBox, options) {
    this.options = options;
    this.$stickyBox = $stickyBox;
    this.init();
  }

  var StickyScrollBlockPrototype = {
    init: function init() {
      this.findElements();
      this.attachEvents();
      this.makeCallback('onInit');
    },
    findElements: function findElements() {
      // find parent container in which will be box move
      this.$container = this.$stickyBox.closest(this.options.container); // define box wrap flag

      this.isWrap = this.options.positionType === 'fixed' && this.options.setBoxHeight; // define box move flag

      this.moveInContainer = !!this.$container.length; // wrapping box to set place in content

      if (this.isWrap) {
        this.$stickyBoxWrap = this.$stickyBox.wrap('<div class="' + this.getWrapClass() + '"/>').parent();
      } //define block to add active class


      this.parentForActive = this.getParentForActive();
      this.isInit = true;
    },
    attachEvents: function attachEvents() {
      var self = this; // bind events

      this.onResize = function () {
        if (!self.isInit) return;
        self.resetState();
        self.recalculateOffsets();
        self.checkStickyPermission();
        self.scrollHandler();
      };

      this.onScroll = function () {
        self.scrollHandler();
      }; // initial handler call


      this.onResize(); // handle events

      $win.on('load resize orientationchange', this.onResize).on('scroll', this.onScroll);
    },
    defineExtraTop: function defineExtraTop() {
      // define box's extra top dimension
      var extraTop;

      if (typeof this.options.extraTop === 'number') {
        extraTop = this.options.extraTop;
      } else if (typeof this.options.extraTop === 'function') {
        extraTop = this.options.extraTop();
      }

      this.extraTop = this.options.positionType === 'absolute' ? extraTop : Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
    },
    checkStickyPermission: function checkStickyPermission() {
      // check the permission to set sticky
      this.isStickyEnabled = this.moveInContainer ? this.data.containerOffsetTop + this.data.containerHeight > this.data.boxFullHeight + this.data.boxOffsetTop + this.options.extraBottom : true;
    },
    getParentForActive: function getParentForActive() {
      if (this.isWrap) {
        return this.$stickyBoxWrap;
      }

      if (this.$container.length) {
        return this.$container;
      }

      return this.$stickyBox;
    },
    getWrapClass: function getWrapClass() {
      // get set of container classes
      try {
        return this.$stickyBox.attr('class').split(' ').map(function (name) {
          return 'sticky-wrap-' + name;
        }).join(' ');
      } catch (err) {
        return 'sticky-wrap';
      }
    },
    resetState: function resetState() {
      // reset dimensions and state
      this.stickyFlag = false;
      this.$stickyBox.css({
        '-webkit-transition': '',
        '-webkit-transform': '',
        transition: '',
        transform: '',
        position: '',
        width: '',
        left: '',
        top: ''
      }).removeClass(this.options.activeClass);

      if (this.isWrap) {
        this.$stickyBoxWrap.removeClass(this.options.activeClass).removeAttr('style');
      }

      if (this.moveInContainer) {
        this.$container.removeClass(this.options.activeClass);
      }
    },
    recalculateOffsets: function recalculateOffsets() {
      // define box and container dimensions
      this.winParams = this.getWindowParams();
      this.data = $.extend(this.getBoxOffsets(), this.getContainerOffsets());
      this.defineExtraTop();
    },
    getBoxOffsets: function getBoxOffsets() {
      var boxOffset = this.$stickyBox.offset();
      var boxPosition = this.$stickyBox.position();
      return {
        // sticky box offsets
        boxOffsetLeft: boxOffset.left,
        boxOffsetTop: boxOffset.top,
        // sticky box positions
        boxTopPosition: boxPosition.top,
        boxLeftPosition: boxPosition.left,
        // sticky box width/height
        boxFullHeight: this.$stickyBox.outerHeight(true),
        boxHeight: this.$stickyBox.outerHeight(),
        boxWidth: this.$stickyBox.outerWidth()
      };
    },
    getContainerOffsets: function getContainerOffsets() {
      var containerOffset = this.moveInContainer ? this.$container.offset() : null;
      return containerOffset ? {
        // container offsets
        containerOffsetLeft: containerOffset.left,
        containerOffsetTop: containerOffset.top,
        // container height
        containerHeight: this.$container.outerHeight()
      } : {};
    },
    getWindowParams: function getWindowParams() {
      return {
        height: window.innerHeight || document.documentElement.clientHeight
      };
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function destroy() {
      this.isInit = false; // remove event handlers and styles

      $win.off('load resize orientationchange', this.onResize).off('scroll', this.onScroll);
      this.resetState();
      this.$stickyBox.removeData('StickyScrollBlock');

      if (this.isWrap) {
        this.$stickyBox.unwrap();
      }

      this.makeCallback('onDestroy');
    }
  };
  var stickyMethods = {
    fixed: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop - (this.options.showAfterScrolled ? this.extraTop : 0) - (this.options.showAfterScrolled ? this.data.boxHeight + this.extraTop : 0) > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            position: this.options.positionType
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.setDynamicPosition();
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.stickyFlag = false;
          this.resetState();
          this.makeCallback('fixedOff');
        }
      },
      setDynamicPosition: function setDynamicPosition() {
        this.$stickyBox.css({
          top: this.getTopPosition(),
          left: this.data.boxOffsetLeft - $win.scrollLeft()
        });
      },
      getTopPosition: function getTopPosition() {
        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          return Math.min(this.extraTop, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop);
        } else {
          return this.extraTop;
        }
      }
    },
    absolute: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            transition: 'transform ' + this.options.animSpeed + 's ease',
            '-webkit-transition': 'transform ' + this.options.animSpeed + 's ease'
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.clearTimer();
        this.timer = setTimeout(function () {
          this.setDynamicPosition();
        }.bind(this), this.options.animDelay * 1000);
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.clearTimer();
          this.stickyFlag = false;
          this.timer = setTimeout(function () {
            this.setDynamicPosition();
            setTimeout(function () {
              this.resetState();
            }.bind(this), this.options.animSpeed * 1000);
          }.bind(this), this.options.animDelay * 1000);
          this.makeCallback('fixedOff');
        }
      },
      clearTimer: function clearTimer() {
        clearTimeout(this.timer);
      },
      setDynamicPosition: function setDynamicPosition() {
        var topPosition = Math.max(0, this.getTopPosition());
        this.$stickyBox.css({
          transform: 'translateY(' + topPosition + 'px)',
          '-webkit-transform': 'translateY(' + topPosition + 'px)'
        });
      },
      getTopPosition: function getTopPosition() {
        var currTopPosition = this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          var diffOffset = Math.abs(Math.min(0, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop - this.extraTop));
          return currTopPosition - diffOffset;
        } else {
          return currTopPosition;
        }
      }
    }
  }; // jQuery plugin interface

  $.fn.stickyScrollBlock = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var options = $.extend({
      container: null,
      positionType: 'fixed',
      // 'fixed' or 'absolute'
      activeClass: 'fixed-position',
      setBoxHeight: true,
      showAfterScrolled: false,
      extraTop: 0,
      extraBottom: 0,
      animDelay: 0.1,
      animSpeed: 0.2
    }, opt);
    return this.each(function () {
      var $stickyBox = jQuery(this);
      var instance = $stickyBox.data('StickyScrollBlock');

      if (_typeof(opt) === 'object' || typeof opt === 'undefined') {
        StickyScrollBlock.prototype = $.extend(stickyMethods[options.positionType], StickyScrollBlockPrototype);
        $stickyBox.data('StickyScrollBlock', new StickyScrollBlock($stickyBox, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  }; // module exports


  window.StickyScrollBlock = StickyScrollBlock;
})(jQuery, jQuery(window));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./components/row-hover-helper":3,"./components/slick-with-indicator":4,"./components/youtube-deferred":5,"./jquery-plugins/jquery-serialshuffle.js":6,"impv-support/src/js/components/smooth-scroll":8,"impv/src/js/components/stycky-pagination.js":9}],8:[function(require,module,exports){
"use strict";

/*
 * SmoothScroll module
 */
(function ($, exports) {
  // private variables
  var page,
      win = $(window),
      activeBlock,
      _activeWheelHandler,
      wheelEvents = 'onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll'; // animation handlers


  function _scrollTo(offset, options, callback) {
    // initialize variables
    var scrollBlock;

    if (document.body) {
      if (typeof options === 'number') {
        options = {
          duration: options
        };
      } else {
        options = options || {};
      }

      page = page || $('html, body');
      scrollBlock = options.container || page;
    } else {
      return;
    } // treat single number as scrollTop


    if (typeof offset === 'number') {
      offset = {
        top: offset
      };
    } // handle mousewheel/trackpad while animation is active


    if (activeBlock && _activeWheelHandler) {
      activeBlock.off(wheelEvents, _activeWheelHandler);
    }

    if (options.wheelBehavior && options.wheelBehavior !== 'none') {
      _activeWheelHandler = function activeWheelHandler(e) {
        if (options.wheelBehavior === 'stop') {
          scrollBlock.off(wheelEvents, _activeWheelHandler);
          scrollBlock.stop();
        } else if (options.wheelBehavior === 'ignore') {
          e.preventDefault();
        }
      };

      activeBlock = scrollBlock.on(wheelEvents, _activeWheelHandler);
    } // start scrolling animation


    scrollBlock.stop().animate({
      scrollLeft: offset.left,
      scrollTop: offset.top
    }, options.duration, function () {
      if (_activeWheelHandler) {
        scrollBlock.off(wheelEvents, _activeWheelHandler);
      }

      if ($.isFunction(callback)) {
        callback();
      }
    });
  } // smooth scroll contstructor


  function SmoothScroll(options) {
    this.options = $.extend({
      anchorLinks: 'a[href^="#"]',
      // selector or jQuery object
      container: null,
      // specify container for scrolling (default - whole page)
      extraOffset: null,
      // function or fixed number
      activeClasses: null,
      // null, "link", "parent"
      easing: 'swing',
      // easing of scrolling
      animMode: 'duration',
      // or "speed" mode
      animDuration: 800,
      // total duration for scroll (any distance)
      animSpeed: 1500,
      // pixels per second
      anchorActiveClass: 'anchor-active',
      sectionActiveClass: 'section-active',
      wheelBehavior: 'stop',
      // "stop", "ignore" or "none"
      useNativeAnchorScrolling: false // do not handle click in devices with native smooth scrolling

    }, options);
    this.init();
  }

  SmoothScroll.prototype = {
    init: function init() {
      this.initStructure();
      this.attachEvents();
      this.isInit = true;
    },
    initStructure: function initStructure() {
      var self = this;
      this.container = this.options.container ? $(this.options.container) : $('html,body');
      this.scrollContainer = this.options.container ? this.container : win;
      this.anchorLinks = jQuery(this.options.anchorLinks).filter(function () {
        return jQuery(self.getAnchorTarget(jQuery(this))).length;
      });
    },
    getId: function getId(str) {
      try {
        return '#' + str.replace(/^.*?(#|$)/, '');
      } catch (err) {
        return null;
      }
    },
    getAnchorTarget: function getAnchorTarget(link) {
      // get target block from link href
      var targetId = this.getId($(link).attr('href'));
      return $(targetId.length > 1 ? targetId : 'html');
    },
    getTargetOffset: function getTargetOffset(block) {
      // get target offset
      var blockOffset = block.offset().top;

      if (this.options.container) {
        blockOffset -= this.container.offset().top - this.container.prop('scrollTop');
      } // handle extra offset


      if (typeof this.options.extraOffset === 'number') {
        blockOffset -= this.options.extraOffset;
      } else if (typeof this.options.extraOffset === 'function') {
        blockOffset -= this.options.extraOffset(block);
      }

      return {
        top: blockOffset
      };
    },
    attachEvents: function attachEvents() {
      var self = this; // handle active classes

      if (this.options.activeClasses && this.anchorLinks.length) {
        // cache structure
        this.anchorData = [];

        for (var i = 0; i < this.anchorLinks.length; i++) {
          var link = jQuery(this.anchorLinks[i]),
              targetBlock = self.getAnchorTarget(link),
              anchorDataItem = null;
          $.each(self.anchorData, function (index, item) {
            if (item.block[0] === targetBlock[0]) {
              anchorDataItem = item;
            }
          });

          if (anchorDataItem) {
            anchorDataItem.link = anchorDataItem.link.add(link);
          } else {
            self.anchorData.push({
              link: link,
              block: targetBlock
            });
          }
        } // add additional event handlers


        this.resizeHandler = function () {
          if (!self.isInit) return;
          self.recalculateOffsets();
        };

        this.scrollHandler = function () {
          self.refreshActiveClass();
        };

        this.recalculateOffsets();
        this.scrollContainer.on('scroll', this.scrollHandler);
        win.on('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
      } // handle click event


      this.clickHandler = function (e) {
        self.onClick(e);
      };

      if (!this.options.useNativeAnchorScrolling) {
        this.anchorLinks.on('click', this.clickHandler);
      }
    },
    recalculateOffsets: function recalculateOffsets() {
      var self = this;
      $.each(this.anchorData, function (index, data) {
        data.offset = self.getTargetOffset(data.block);
        data.height = data.block.outerHeight();
      });
      this.refreshActiveClass();
    },
    toggleActiveClass: function toggleActiveClass(anchor, block, state) {
      anchor.toggleClass(this.options.anchorActiveClass, state);
      block.toggleClass(this.options.sectionActiveClass, state);
    },
    refreshActiveClass: function refreshActiveClass() {
      var self = this,
          foundFlag = false,
          containerHeight = this.container.prop('scrollHeight'),
          viewPortHeight = this.scrollContainer.height(),
          scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop(); // user function instead of default handler

      if (this.options.customScrollHandler) {
        this.options.customScrollHandler.call(this, scrollTop, this.anchorData);
        return;
      } // sort anchor data by offsets


      this.anchorData.sort(function (a, b) {
        return a.offset.top - b.offset.top;
      }); // default active class handler

      $.each(this.anchorData, function (index) {
        var reverseIndex = self.anchorData.length - index - 1,
            data = self.anchorData[reverseIndex],
            anchorElement = self.options.activeClasses === 'parent' ? data.link.parent() : data.link;

        if (scrollTop >= containerHeight - viewPortHeight) {
          // handle last section
          if (reverseIndex === self.anchorData.length - 1) {
            self.toggleActiveClass(anchorElement, data.block, true);
          } else {
            self.toggleActiveClass(anchorElement, data.block, false);
          }
        } else {
          // handle other sections
          if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
            foundFlag = true;
            self.toggleActiveClass(anchorElement, data.block, true);
          } else {
            self.toggleActiveClass(anchorElement, data.block, false);
          }
        }
      });
    },
    calculateScrollDuration: function calculateScrollDuration(offset) {
      var distance;

      if (this.options.animMode === 'speed') {
        distance = Math.abs(this.scrollContainer.scrollTop() - offset.top);
        return distance / this.options.animSpeed * 1000;
      } else {
        return this.options.animDuration;
      }
    },
    onClick: function onClick(e) {
      var targetBlock = this.getAnchorTarget(e.currentTarget),
          targetOffset = this.getTargetOffset(targetBlock);
      e.preventDefault();

      _scrollTo(targetOffset, {
        container: this.container,
        wheelBehavior: this.options.wheelBehavior,
        duration: this.calculateScrollDuration(targetOffset)
      });

      this.makeCallback('onBeforeScroll', e.currentTarget);
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function destroy() {
      var self = this;
      this.isInit = false;

      if (this.options.activeClasses) {
        win.off('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
        this.scrollContainer.off('scroll', this.scrollHandler);
        $.each(this.anchorData, function (index) {
          var reverseIndex = self.anchorData.length - index - 1,
              data = self.anchorData[reverseIndex],
              anchorElement = self.options.activeClasses === 'parent' ? data.link.parent() : data.link;
          self.toggleActiveClass(anchorElement, data.block, false);
        });
      }

      this.anchorLinks.off('click', this.clickHandler);
    }
  }; // public API

  $.extend(SmoothScroll, {
    scrollTo: function scrollTo(blockOrOffset, durationOrOptions, callback) {
      _scrollTo(blockOrOffset, durationOrOptions, callback);
    }
  }); // export module

  exports.SmoothScroll = SmoothScroll;
})(jQuery, window);

},{}],9:[function(require,module,exports){
"use strict";

(function ($) {
  $(document).ready(function () {
    $('.navigation-dot').on('click', function (e) {
      var sectionPosition = $(e.currentTarget).attr('data-anchor');
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.navigation-anchor[anchor="' + sectionPosition + '"]').offset().top - 60
      }, 1000);
    });

    function Utils() {}

    Utils.prototype = {
      constructor: Utils,
      isElementInView: function isElementInView(element, fullyInView, gridTop, gridBottom) {
        var pageTop = $(window).scrollTop() + gridTop;
        var pageBottom = pageTop + $(window).height() - gridBottom;
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
          return pageTop < elementTop && pageBottom > elementBottom;
        } else {
          return elementTop <= pageBottom && elementBottom >= pageTop;
        }
      }
    };
    var Utils = new Utils();
    var windowHeight = $(window).height(),
        top = 0.0,
        bottom = 0.5,
        gridTop = windowHeight * top,
        gridBottom = windowHeight * bottom;
    $(window).on('load scroll', function () {
      $('.navigation-anchor').each(function (_, e) {
        var isElementInView = Utils.isElementInView($(e), false, gridTop, gridBottom);

        if (isElementInView) {
          var navigationPosition = $(e).attr('anchor');
          var $currentNavigation = $('.navigation-dot[data-anchor="' + navigationPosition + '"]');
          $currentNavigation.addClass('active');
          $currentNavigation.siblings().each(function (_, e) {
            $(e).removeClass('active');
          });
        }
      });
    });
  });
})(jQuery);

},{}]},{},[1]);
